import React from 'react';

import PropTypes from 'prop-types';

import { FormField } from 'components/FormHelper/FormField';
import { HintText } from 'components/HintText/HintText';
import { HINTTEXT_TYPE } from 'components/HintText/HintTextType';

const DEFAULT_HINT_TEXT =
  'Mit dem optionalen Zugang für die Fachkraft haben Sie Zugriff auf das mein.Auftragsportal und auf das e-fix. Sie können damit auch die Portale der Schwesterunternehmen verwenden. Der Informationsaustausch aus dem mein.Auftragsportal heraus wird weiterhin über Ihre Firmen E-Mail Adresse erfolgen. Mit dem Einzelzugang sehen Sie alle angelegten Aufträge ihrer Firma, auch die weiterer Fachkräfte, und können diese bearbeiten.';

export const DEBExpertPopupContactSection = ({ formik, isEditing, emailRequired, hintText }) => {
  const emailField = isEditing ? 'newEmail' : 'netzportalEmail';
  const showConfirm = Boolean(formik.values[emailField]);

  return (
    <>
      <div className="popup-content__popup-field">
        <FormField name="telefon" formik={formik} label="Telefonnummer" oldValue="" fullWidth />
      </div>

      {isEditing && (
        <FormField
          name="netzportalEmail"
          formik={formik}
          label="E-Mail-Adresse"
          readOnly
          oldValue=""
          fullWidth
        />
      )}
      <HintText type={HINTTEXT_TYPE.INFO}>{hintText}</HintText>
      <FormField
        name={emailField}
        formik={formik}
        label={isEditing ? 'Neue E-Mail-Adresse' : `E-Mail-Adresse${emailRequired ? '*' : ''}`}
        oldValue=""
        fullWidth
      />

      {showConfirm && (
        <FormField
          name="confirmEmail"
          formik={formik}
          label={isEditing ? 'Neue E-Mail-Adresse bestätigen' : 'E-Mail-Adresse bestätigen'}
          oldValue=""
          fullWidth
        />
      )}
    </>
  );
};

DEBExpertPopupContactSection.propTypes = {
  formik: PropTypes.object.isRequired,
  isEditing: PropTypes.bool,
  emailRequired: PropTypes.bool,
  hintText: PropTypes.node,
};

DEBExpertPopupContactSection.defaultProps = {
  isEditing: false,
  emailRequired: false,
  hintText: DEFAULT_HINT_TEXT,
};
